import {SvgProps} from '@website/types';

import React from 'react';

const RightArrowIcon: React.FC<SvgProps> = ({
  fill = 'currentColor',
  className,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="17"
      viewBox="0 0 15 13"
      fill="none"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.56025 8.5L0.5 1.87853L1.96987 0.5L10.5 8.5L1.96987 16.5L0.5 15.1215L7.56025 8.5Z"
        fill={fill}
        stroke="currentColor"
      />
    </svg>
  );
};

export default RightArrowIcon;
